import FileUploadNoText from "../../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import {ExchangeMapType, ExchangeSearchParamType} from "../interface";
import {useModal} from "../../../../../hooks";
import {useUploadExchangeRateExcel} from "../hooks/useUploadExchangeRateExcel";
import {Dispatch, SetStateAction} from "react";
import {useUser} from "../../../../../util/userContext/UserContext";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    exchange: ExchangeMapType
    searchParam: ExchangeSearchParamType;
    setSearchParam: Dispatch<SetStateAction<ExchangeSearchParamType>>
    searchCallback: (param: ExchangeSearchParamType) => any
}

export default function Table({exchange, searchParam, setSearchParam, searchCallback}: PropsType) {
    const {handleModal} = useModal();
    const {user} = useUser();

    const exchangeData = exchange.searchExchangeResMap;

    const {mutateAsync: mutateAsyncUploadExchangeRateExcel} = useUploadExchangeRateExcel()

    const btnImportExcel = (file: File[]) => {
        if (file.length === 0) {
            handleModal({
                isOpen: true,
                contents: "파일을 선택해주세요.",
                type: "alert"
            })
        } else {
            const fd = new FormData()
            fd.append("excelFile", file.at(0) as File)

            mutateAsyncUploadExchangeRateExcel(fd).then(res => {
                const data = res.data
                if (data.code === "0000") {
                    handleModal({
                        isOpen: true,
                        contents: "등록되었습니다.",
                        type: "alert",
                        closeAction: () => {
                            const object = res.data.result.exchangeRateVOList

                            let date = ""
                            for (const objectKey in object) {
                                date = object[objectKey]?.noticeBaseDate
                            }

                            setSearchParam({
                                ...searchParam,
                                keywordType2: "205",
                                keywordType2Name: "지정일",
                                startAt: date,
                                endAt: date
                            })
                            searchCallback({
                                ...searchParam,
                                keywordType2: "205",
                                keywordType2Name: "지정일",
                                startAt: date,
                                endAt: date
                            })
                        }
                    });
                } else {
                    handleModal({
                        isOpen: true,
                        contents: data.msg,
                        type: "alert"
                    })
                }
            })
        }
    }

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">환율정보 상세보기</h6>
            <div className="table_toolbar">
                <div className="stats">
                    <div
                        className="stats_item">기준일<span>{exchangeData.USD.noticeBaseDate !== "" ? exchangeData.USD.noticeBaseDate : "-"}</span>
                    </div>
                    <div
                        className="stats_item">고시회차<span>{exchangeData.USD.noticeRound !== "" ? exchangeData.USD.noticeRound : "-"}</span>
                    </div>
                </div>
                {user && user.inOutFlag === 0 &&
                    <FileUploadNoText
                        addFileCallback={(file: File[]) => btnImportExcel(file)}
                        customRenderer={(onClick: any, disabled: any) =>
                            <button className="btn btn-outline-dark w-150px px-0"
                                    onClick={onClick}
                                    disabled={disabled}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt=""/>엑셀 가져오기
                            </button>}
                        accept={".xlsx, .xls"}
                    />
                }
            </div>
        </div>
        {/* 내부수정: 미화환산율 */}       
        <table className="table table-bordered my_table mb-0">
            <thead>
            <tr>
                <th rowSpan={2} style={{width: "15%"}}>통화</th>
                <th colSpan={2} style={{width: "30%"}}>현찰</th>
                <th colSpan={2} style={{width: "30%"}}>송금</th>
                <th rowSpan={2} style={{width: "15%"}}>매매기준율</th>
                <th rowSpan={2}>미화환산율</th>
            </tr>
            <tr>
                <th style={{width: "15%"}}>사실 때</th>
                <th style={{width: "15%"}}>파실 때</th>
                <th style={{width: "15%"}}>보낼 때</th>
                <th style={{width: "15%"}}>받을 때</th>
            </tr>
            </thead>
            <tbody>
            {(() => {
                const keys = ["USD", "CHN", "HK", "SEA", "ANZ", "MY", "IND",]

                return keys.map(key => {
                    const exchange = exchangeData[key as keyof ExchangeMapType["searchExchangeResMap"]]

                    return <tr>
                        <td className="text-center">{exchange.currencyType}</td>
                        <td className="text-end"><DisplayNumber value={exchange.cashBuyRate}/></td>
                        <td className="text-end"><DisplayNumber value={exchange.cashSellRate}/></td>
                        <td className="text-end"><DisplayNumber value={exchange.remittanceSendRate}/></td>
                        <td className="text-end"><DisplayNumber value={exchange.remittanceReceiveRate}/></td>
                        <td className="text-end"><DisplayNumber value={exchange.baseExchangeRate}/></td>
                        <td className="text-end"><DisplayNumber value={exchange.usdConversionRate} decimalScale={4}/></td>
                    </tr>
                })
            })()}
            </tbody>
        </table>

    </div>
}